import { Button, Flex } from '@styles';
import { ReactComponent as PreviousIcon } from '@svgs/chevron-left.svg';
import { ReactComponent as NextIcon } from '@svgs/chevron-right.svg';
import { bool, func, number } from 'prop-types';
import React from 'react';

import { Icon } from '../Icon';

const CarouselButtons = ({
  bottomOffset,
  height,
  isMobile,
  next,
  previous,
  rightOffset,
  width,
}) => (
  <Flex
    gap={8}
    position="absolute"
    right={rightOffset || 0}
    {...(isMobile && { bottom: bottomOffset })}
  >
    <Button
      borderRadius={200}
      height={height || 93}
      onClick={previous}
      p={0}
      variant="secondary"
      width={width || 93}
    >
      <Icon SVG={PreviousIcon} />
    </Button>
    <Button
      borderRadius={200}
      height={height || 93}
      onClick={next}
      p={0}
      variant="secondary"
      width={width || 93}
    >
      <Icon SVG={NextIcon} />
    </Button>
  </Flex>
);

CarouselButtons.propTypes = {
  bottomOffset: number,
  height: number,
  isMobile: bool,
  next: func.isRequired,
  previous: func.isRequired,
  rightOffset: number,
  width: number,
};

CarouselButtons.defaultProps = {
  bottomOffset: 0,
  height: 0,
  isMobile: false,
  rightOffset: 0,
  width: 0,
};

export default CarouselButtons;
